// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.form-container .material-symbols-outlined {
  font-size: 14px;
}

.settingsButton .p-button-label {
  font-weight: 700 !important;
}

.truncate-text {
  width: 100%;
  max-width: 65vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* Large devices (desktops, 992px and up) */
}
@media only screen and (min-width: 601px) {
  .truncate-text {
    max-width: 75vw;
  }
}
@media only screen and (min-width: 992px) {
  .truncate-text {
    max-width: 60vw;
  }
}

.truncate-span {
  display: block;
  max-width: 30vw;
}

.industry-input-disabled {
  opacity: 0.6;
}`, "",{"version":3,"sources":["webpack://./src/app/main/apps/components/settings-form/settings-form.component.scss"],"names":[],"mappings":"AACI;EACI,eAAA;AAAR;;AAMI;EACI,2BAAA;AAHR;;AAOA;EACI,WAAA;EACA,eAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EAMA,2CAAA;AATJ;AAKI;EAPJ;IAQQ,eAAA;EAFN;AACF;AAKI;EAZJ;IAaQ,eAAA;EAFN;AACF;;AAMA;EACI,cAAA;EACA,eAAA;AAHJ;;AAMA;EACI,YAAA;AAHJ","sourcesContent":[".form-container {\n    .material-symbols-outlined {\n        font-size: 14px;\n    }\n}\n\n\n.settingsButton {\n    .p-button-label {\n        font-weight: 700 !important;\n    }\n}\n\n.truncate-text {\n    width: 100%;\n    max-width: 65vw;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n\n    @media only screen and (min-width: 601px) {\n        max-width: 75vw;\n    }\n\n    /* Large devices (desktops, 992px and up) */\n    @media only screen and (min-width: 992px) {\n        max-width: 60vw;\n    }\n}\n\n\n.truncate-span {\n    display: block;\n    max-width: 30vw;\n}\n\n.industry-input-disabled {\n    opacity: 0.6;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
